import React, { Fragment } from 'react';
import '../../_assets/css/file.css';
import './style.css';

import { Form } from "react-bootstrap";
import axios from 'axios';
import ReactDatatable from '@ashvin27/react-datatable';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { baseURL } from '../../_helpers';
import { TOKEN, ROLE } from '../../_helpers/exports';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
// import { Customers } from './customer_view';
import Input from 'react-phone-number-input/input'
import { Link } from 'react-router-dom';
import Alert from '../../shared/components/Alert';
// import CreateAddress from '../Address/createCustomerAddress';
import * as moment from 'moment';
import Modal from 'react-modal';
import { MDBCloseIcon } from "mdbreact"
import RefreshIcon from 'mdi-react/RefreshCircleIcon';
import { logRoles } from '@testing-library/react';

import Select from 'react-select';

class ClientDetails extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
    };
    constructor(props) {
        super(props)
        this.getDataUpdate = this.getDataUpdate.bind(this);
        this.handleFromDateUpdate = this.handleFromDateUpdate.bind(this);
        this.handleToDateUpdate = this.handleToDateUpdate.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onSubmitCreate = this.onSubmitCreate.bind(this);
        this.onSubmitModify = this.onSubmitModify.bind(this);
        this.onSubmitFloat = this.onSubmitFloat.bind(this);

        this.state = {
            showComponent: false,
            hideComponent: true,
            moreinfo: false,
            isLoading: false,
            isShowError: false,
            isOpenCreate: false,
            isOpen: false,
            isOpenModify: false,
            isOpenFloat: false,
            startDate: new Date(),
            endDate: new Date(),
            statusMessage: '',
            showError: false,


        }
        this.client = [
            {
                label: 'True',
                value: true
            },
            {
                label: 'False',
                value: false
            },
        ];

        this.columnsadmin = [
            {
                key: "id",
                TrOnlyClassName: 'tsc',
                text: "Client id",
                className: "tsc",
                align: "left"
            },
            {
                key: "name",
                TrOnlyClassName: 'tsc',
                text: "Client Name",
                className: "tsc",
                align: "left"
            },

            {
                key: "verification_status2",
                TrOnlyClassName: 'tsc',
                text: "Enabled",
                className: "tsc",
                align: "left",
                cell: record => {
                    return (
                        <Fragment className="center"  >
                            {record.verification_status2 === "false" ?
                                <div>
                                    <span class="badge-danger" style={{ borderRadius: "5px", padding: "2px" }}>
                                        False
                                </span>
                                </div>
                                : null}
                            {record.verification_status2 === "true" ?
                                <span class="badge-success" style={{ borderRadius: "5px", padding: "2px" }}>
                                    True
                                </span>
                                : null}
                        </Fragment >
                    );
                }
            },

            {
                key: "date_created",
                TrOnlyClassName: 'tsc',
                text: "Date Created",
                className: "tsc",
                align: "left"
            },
            {
                key: "action",
                text: "Options",
                TrOnlyClassName: 'cell',
                className: "cell",
                width: 250,
                sortable: false,
                cell: record => {
                    return (
                        <Fragment className="center"  >
                            {ROLE == 1 ?
                                <div>

                                    {record.verification_status2 === "false" ?
                                        <button className="btn btn-primary  btn-sm"
                                            title="View"
                                            style={
                                                { marginRight: '10px' }}
                                            onClick={
                                                () => { if (window.confirm('Are you sure you want to enable this client?')) this.onSubmitModify(record) }}
                                        >
                                            Enable Client
                                        </button>
                                        : null}
                                    {record.verification_status2 === "true" ?
                                        <button className="btn btn-primary  btn-sm"
                                            title="View"
                                            style={
                                                { marginRight: '10px' }}
                                            onClick={
                                                () => { if (window.confirm('Are you sure you want to disabled this agent?')) this.onSubmitDisabled(record) }}
                                        >
                                            Disabled Client
                                         </button>
                                        : null}

                                </div>
                                : <div>_</div>}
                        </Fragment >
                    );
                }
            },

        ]

        this.columns = [
            {
                key: "id",
                TrOnlyClassName: 'tsc',
                text: "Client id",
                className: "tsc",
                align: "left"
            },
            {
                key: "name",
                TrOnlyClassName: 'tsc',
                text: "Name",
                className: "tsc",
                align: "left"
            },

            {
                key: "verification_status2",
                TrOnlyClassName: 'tsc',
                text: "Verify",
                className: "tsc",
                align: "left"
            // },
            // {
            //     key: "action",
            //     text: "Options",
            //     TrOnlyClassName: 'cell',
            //     width: 250,
            //     sortable: false,
            //     cell: record => {
            //         return (
            //             <Fragment className="center"  >
            //                 {ROLE == 2 ?
            //                     <div>
            //                         {record.customer_verification == true ?
            //                             <button className="btn btn-success  btn-sm"
            //                                 title="View"
            //                                 style={
            //                                     { marginRight: '10px' }}
            //                                 onClick={
            //                                     () => { this.toggleModal(record) }} >
            //                                 Verify
            //                                   </button>
            //                             : null}
            //                         <button className="btn btn-primary  btn-sm"
            //                             title="View"
            //                             style={
            //                                 { marginRight: '10px' }}
            //                             onClick={
            //                                 () => { this.toggleModalFloat(record) }} >
            //                             Sell Float
            //                            </button>
            //                     </div>
            //                     : null}
            //                 {ROLE == 1 ?
            //                     <div>
            //                         <button className="btn btn-success  btn-sm"
            //                             title="View"
            //                             style={
            //                                 { marginRight: '10px' }}
            //                             onClick={
            //                                 () => { this.toggleModalModify(record) }} >
            //                             Modify Client
            //                        </button>
            //                     </div>
            //                     : null}
            //             </Fragment >
            //         );
            //     }
            },

        ]
        this.config = {
            key_column: "tsc",
            length_menu: [10, 20, 50],
            show_filter: false,
            show_pagination: true,
            pagination: 'advance',
            page_size: 10,
            show_length_menu: true,
            language: {
                loading_text: "Please be patient while data loads...",
                filter: "Search...",
                no_data_text: "No data was found",
                pagination: {
                    next: <span>&#9658;</span>,
                    previous: <span>&#9668;</span>
                    // next
                    // previous
                }
            }
        }
    }

    handleFromDateUpdate(date) {
        this.setState({
            startDate: date.date
        })
    }
    handleToDateUpdate(date) {
        this.setState({
            endDate: date.date
        })
    }

    getDataUpdate() {
        this.getData();
    }
    componentDidMount() {
        this.getData();
    }
    getData = (queryString = "") => {
        let formData = {
            "session_id": TOKEN
        }
        this.setState({
            isLoading: true
        })
        let url = baseURL + "get_clients"
        axios.all([
            axios.post(url, formData),
        ]).then(axios.spread((clientResponse) => {
            this.setState({
                client: clientResponse.data.clients,
                isLoading: false
            }, function () {
                var data = [];

                for (let i = 0; i < this.state.client.length; i++) {
                    this.setState({
                        total: this.state.client.length
                    })
                    let verification_status;
                    if (ROLE == 2) {
                        verification_status = { verification_status2: this.state.client[i].customer_verification.toString() }
                    } else if (ROLE == 1) {
                        verification_status = { verification_status2: this.state.client[i].enabled.toString() }

                    }
                    data.push(Object.assign(this.state.client[i], verification_status));
                    this.setState({
                        data: data
                    })
                }
            })
        })).catch(error => {
            console.log('bayoo', error.response)
        })
    }
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    toggleModalModify(record) {
        this.setState({
            isOpenModify: true,
            client_id: record.id,
            customer_verification_endpoint: record.customer_verification_endpoint
        });
    };
    toggleModal(record) {
        this.setState({
            client_id: record.id,
            isOpen: true,
        });
    };

    toggleModalCreate = e => {
        this.setState({
            isOpenCreate: true,
        });
    };
    // toggleModalFloat = e => {
    //     this.setState({
    //         isOpenFloat: true,
    //     });
    // };

    toggleModalFloat(record) {
        this.setState({
            isOpenFloat: true,
            client_id: record.id
        });
    };

    onSubmitCreate(e) {
        e.preventDefault();
        let formData = {
            "session_id": TOKEN,
            "name": this.state.client_name,
            "renconciliation_endpoint": "http://10.10.10.10:1001/reconcile"
        }

        this.setState({ isLoading: true });
        axios.post(baseURL + 'add_client', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {
            console.log('bayoo', response.data)
            if (response.data.code === "0000") {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true, isLoading: false });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false });
                    this.closeModalCreate(e)

                    this.getData();
                }, 2000);
            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });

                window.setTimeout(() => {
                    this.setState({
                        isLoading: false,
                        isShowError: false,
                        statusMessage: "",
                        showError: false
                    });
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false, isLoading: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });
            }, 2000);
        })
    }


    onSubmitDisabled(record) {

        let formData = {
            "session_id": TOKEN,
            "customer_verification_endpoint": record.customer_verification_endpoint,
            "client_id": record.id,
            "enabled": false
        }

        this.setState({ isLoading: true });
        axios.post(baseURL + 'modify_client_details', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {
            console.log('bayoo', response.data)
            if (response.data.code === "0000") {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true, isLoading: false });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false });
                    this.getData();
                }, 2000);
            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });
                window.setTimeout(() => {
                    this.setState({
                        isLoading: false,
                        isShowError: false,
                        statusMessage: "",
                        showError: false
                    });
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false, isLoading: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });
            }, 2000);
        })
    }



    onSubmitModify(record) {

        let formData = {
            "session_id": TOKEN,
            "customer_verification_endpoint": record.customer_verification_endpoint,
            "client_id": record.id,
            "enabled": true
        }

        // alert(JSON.stringify(formData))

        this.setState({ isLoading: true });
        axios.post(baseURL + 'modify_client_details', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {
            console.log('bayoo', response.data)
            if (response.data.code === "0000") {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true, isLoading: false });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false });
                    this.getData();
                }, 2000);
            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });
                window.setTimeout(() => {
                    this.setState({
                        isLoading: false,
                        isShowError: false,
                        statusMessage: "",
                        showError: false
                    });
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false, isLoading: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });
            }, 2000);
        })
    }

    onSubmit(e) {
        e.preventDefault();

        let formData = {
            "session_id": TOKEN,
            "client_id": this.state.client_id,
            "customer_id": this.state.customer_id,
        }

        this.setState({ isLoading: true });
        axios.post(baseURL + 'verify_customer', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {
            console.log('bayoo', response.data)
            if (response.data.code === "0000") {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true, isLoading: false });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false });
                    this.setState({ isShowError: false });
                    this.getData();
                    this.closeModal(e)
                }, 2000);
            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });

                window.setTimeout(() => {
                    this.setState({
                        isLoading: false,
                        isShowError: false,
                        statusMessage: "",
                        showError: false
                    });
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false, isLoading: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });
            }, 2000);
        })
    }



    onSubmitFloat(e) {
        e.preventDefault();

        let formData = {
            "session_id": TOKEN,
            "client_id": this.state.client_id,
            "customer_id": this.state.customer_id,
            "amount": this.state.amount

        }

        this.setState({ isLoading: true });
        axios.post(baseURL + 'sell_float', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {
            console.log('bayoo', response.data)
            if (response.data.code === "0000") {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true, isLoading: false });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false });
                    this.closeModalFloat(e)
                    this.getData();
                }, 2000);
            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });

                window.setTimeout(() => {
                    this.setState({
                        isLoading: false,
                        isShowError: false,
                        statusMessage: "",
                        showError: false
                    });
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false, isLoading: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });
            }, 2000);
        })
    }

    closeModalCreate = e => {
        this.setState({
            isOpenCreate: false,
        });
    };
    closeModalFloat = e => {
        this.setState({
            isOpenFloat: false,
        });
    };

    closeModalModify = e => {
        this.setState({
            isOpenModify: false,
        });
    };
    closeModal = e => {
        this.setState({
            isOpen: false,
        });
    };


    onSelectChange = value => {
        this.setState(
            {
                enabled: value.value
            });

    };
    render() {
    
    
        return (
            <div>
                <Col md={12} lg={12}>
                    <Card>
                        <CardBody>
                            <div className="row">
                                <div className="col-md-6">
                                    <h4><b>Clients</b></h4><br />
                                </div>
                                <div className="col-md-6">
                                    {ROLE == 1 ?
                                        <div className="center" >
                                            <Button className="float-right" color="primary" onClick={this.toggleModalCreate} outline>Add Client
                                            </Button>
                                        </div>
                                        : null}

                                </div>
                            </div>

                            <div className="col-md-12"><br />
                                <button className="pull-right" title="refresh" style={{ background: "white", border: "0px" }}
                                    onClick={this.getDataUpdate}>
                                    <RefreshIcon />
                                </button>

                                <Modal
                                    isOpen={this.state.isOpen}
                                    onRequestClose={e => {
                                        this.closeModal(e);
                                    }}
                                    contentLabel="My dialog"
                                    className="mymodalclient"
                                    onAfterOpen={() => {
                                        document.body.style.overflow = 'hidden';
                                    }}
                                    onAfterClose={() => {
                                        document.body.removeAttribute('style');
                                    }}
                                    overlayClassName="myoverlay"
                                    closeTimeoutMS={500}
                                >
                                    <MDBCloseIcon onClick={this.closeModal} />
                                    <h4><b>Verify Customer</b></h4><br />

                                    {this.state.showError ? <div >

                                        <Alert color="danger" className="alert--colored" icon>
                                            <p><span className="bold-text">{this.state.statusMessage}</span>
                                            </p>
                                        </Alert>


                                    </div> : null}<br></br>

                                    {this.state.isShowError ? (
                                        <div>

                                            <Alert color="success" className="alert--colored" icon>
                                                <p><span className="bold-text">{this.state.statusMessage}</span>
                                                </p>
                                            </Alert>
                                        </div>
                                    ) : null}
                                    <form className="form" onSubmit={this.onSubmit}>
                                        <div className="col-md-8 offset-2">
                                            <div className="form-group">
                                                <input id="input" type="text" className="form-control"
                                                    name="customer_id" placeholder='Enter Customer ID'
                                                    value={this.state.customer_id} onChange={this.handleChange} />

                                            </div>
                                            <br />

                                        </div>

                                        <div className="col-md-6 offset-2">
                                            <button
                                                type="submit"
                                                onClick={this.check2}
                                                className="pull-right btn btn-primary btn-sm">
                                                {this.state.isLoading ? "Please Wait..." : "Submit"}
                                            </button>
                                        </div>
                                    </form>
                                </Modal>

                                <Modal
                                    isOpen={this.state.isOpenCreate}
                                    onRequestClose={e => {
                                        this.closeModalCreate(e);
                                    }}
                                    contentLabel="My dialog"
                                    className="mymodalclient"
                                    onAfterOpen={() => {
                                        document.body.style.overflow = 'hidden';
                                    }}
                                    onAfterClose={() => {
                                        document.body.removeAttribute('style');
                                    }}
                                    overlayClassName="myoverlay"
                                    closeTimeoutMS={500}
                                >
                                    <MDBCloseIcon onClick={this.closeModalCreate} />
                                    <h4><b>Add Client</b></h4><br />
                                    {this.state.showError ? <div >
                                        <Alert color="danger" className="alert--colored" icon>
                                            <p><span className="bold-text">{this.state.statusMessage}</span>
                                            </p>
                                        </Alert>
                                    </div> : null}<br></br>
                                    {this.state.isShowError ? (
                                        <div>
                                            <Alert color="success" className="alert--colored" icon>
                                                <p><span className="bold-text">{this.state.statusMessage}</span>
                                                </p>
                                            </Alert>
                                        </div>
                                    ) : null}
                                    <form className="form" onSubmit={this.onSubmitCreate}>
                                        <div className="col-md-8 offset-2">
                                            <div className="form-group">
                                                <input id="input" type="text" className="form-control"
                                                    name="client_name" placeholder='Client Name'
                                                    value={this.state.client_name} onChange={this.handleChange} />
                                            </div>
                                            <br />
                                        </div>
                                        <div className="col-md-6 offset-2">
                                            <button
                                                type="submit"
                                                onClick={this.check2}
                                                className="pull-right btn btn-primary btn-sm">
                                                {this.state.isLoading ? "Please Wait..." : "Submit"}
                                            </button>
                                        </div>
                                    </form>
                                </Modal>
                                <Modal
                                    isOpen={this.state.isOpenModify}
                                    onRequestClose={e => {
                                        this.closeModalModify(e);
                                    }}
                                    contentLabel="My dialog"
                                    className="mymodalclient"
                                    onAfterOpen={() => {
                                        document.body.style.overflow = 'hidden';
                                    }}
                                    onAfterClose={() => {
                                        document.body.removeAttribute('style');
                                    }}
                                    overlayClassName="myoverlay"
                                    closeTimeoutMS={500}
                                >
                                    <MDBCloseIcon onClick={this.closeModalModify} />
                                    <h4><b>Modify Client</b></h4><br />
                                    {this.state.showError ? <div >
                                        <Alert color="danger" className="alert--colored" icon>
                                            <p><span className="bold-text">{this.state.statusMessage}</span>
                                            </p>
                                        </Alert>
                                    </div> : null}<br></br>
                                    {this.state.isShowError ? (
                                        <div>
                                            <Alert color="success" className="alert--colored" icon>
                                                <p><span className="bold-text">{this.state.statusMessage}</span>
                                                </p>
                                            </Alert>
                                        </div>
                                    ) : null}
                                    <form className="form" onSubmit={this.onSubmitModify}>
                                        <div className="col-md-8 offset-2">
                                            <div className="form-group">
                                                <h5>Modify Client Status</h5><br />
                                                <Select
                                                    isClearable
                                                    options={this.client}
                                                    placeholder="Enabled"
                                                    autosize={true}
                                                    onChange={this.onSelectChange}
                                                    menuPortalTarget={document.body}
                                                    name="namffe"
                                                />
                                            </div>
                                            <br />
                                        </div>
                                        <div className="col-md-6 offset-2">
                                            <button
                                                type="submit"
                                                onClick={this.check2}
                                                className="pull-right btn btn-primary btn-sm">
                                                {this.state.isLoading ? "Please Wait..." : "Submit"}
                                            </button>
                                        </div>
                                    </form>
                                </Modal>


                                <Modal
                                    isOpen={this.state.isOpenFloat}
                                    onRequestClose={e => {
                                        this.closeModalFloat(e);
                                    }}
                                    contentLabel="My dialog"
                                    className="mymodalclient"
                                    onAfterOpen={() => {
                                        document.body.style.overflow = 'hidden';
                                    }}
                                    onAfterClose={() => {
                                        document.body.removeAttribute('style');
                                    }}
                                    overlayClassName="myoverlay"
                                    closeTimeoutMS={500}
                                >
                                    <MDBCloseIcon onClick={this.closeModalFloat} />
                                    <h4><b>Sell Float</b></h4><br />
                                    {this.state.showError ? <div >
                                        <Alert color="danger" className="alert--colored" icon>
                                            <p><span className="bold-text">{this.state.statusMessage}</span>
                                            </p>
                                        </Alert>
                                    </div> : null}<br></br>
                                    {this.state.isShowError ? (
                                        <div>
                                            <Alert color="success" className="alert--colored" icon>
                                                <p><span className="bold-text">{this.state.statusMessage}</span>
                                                </p>
                                            </Alert>
                                        </div>
                                    ) : null}
                                    <form className="form" onSubmit={this.onSubmitFloat}>
                                        <div className="col-md-8 offset-2">
                                            <div className="form-group">
                                                <input id="input" type="text" className="form-control"
                                                    name="customer_id" placeholder='Customer ID'
                                                    value={this.state.customer_id} onChange={this.handleChange} />
                                            </div>
                                            <br />
                                        </div>
                                        <div className="col-md-8 offset-2">
                                            <div className="form-group">
                                                <input id="input" type="number" className="form-control"
                                                    name="amount" placeholder='Amount'
                                                    value={this.state.amount} onChange={this.handleChange} />
                                            </div>
                                            <br />
                                        </div>
                                        <div className="col-md-6 offset-2">
                                            <button
                                                type="submit"
                                                onClick={this.check2}
                                                className="pull-right btn btn-primary btn-sm">
                                                {this.state.isLoading ? "Please Wait..." : "Submit"}
                                            </button>
                                        </div>
                                    </form>
                                </Modal>
                                {this.state.showError ? <div >

                                    <Alert color="danger" className="alert--colored" icon>
                                        <p><span className="bold-text">{this.state.statusMessage}</span>
                                        </p>
                                    </Alert>


                                </div> : null}<br></br>

                                {this.state.isShowError ? (
                                    <div>

                                        <Alert color="success" className="alert--colored" icon>
                                            <p><span className="bold-text">{this.state.statusMessage}</span>
                                            </p>
                                        </Alert>
                                    </div>
                                ) : null}
                                {ROLE === '1' ?
                                    <ReactDatatable
                                        config={this.config}
                                        records={this.state.data}
                                        columns={this.columnsadmin}
                                        dynamic={true}
                                        id="tsc"
                                        loading={this.state.isLoading}
                                        total_record={this.state.total}
                                        onChange={this.tableChangeHandler} />
                                    : null}
                                {ROLE === '2' ?
                                    <ReactDatatable
                                        config={this.config}
                                        records={this.state.data}
                                        columns={this.columns}
                                        dynamic={true}
                                        id="tsc"
                                        loading={this.state.isLoading}
                                        total_record={this.state.total}
                                        onChange={this.tableChangeHandler} />
                                    : null}

                            </div>



                        </CardBody>
                    </Card>
                </Col >

            </div>
        )
    }
}
export default withTranslation('common')(ClientDetails);
